import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function FrontMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Front Office Billing</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/fo-lab-entry"><button type="button" className="btn btn"><span >Lab Request</span></button></a></div>
                    <div className="btn-group">
                    <a href="/fo-inv-entry"><button type="button" className="btn btn"><span >Investigation Request</span></button></a></div>
                    <div className="btn-group">
                    <a href="/cashier-lab"><button type="button" className="btn btn"><span >Lab Approvals</span></button></a></div>
                    <div className="btn-group">
                    <a href="/cashier-inv"><button type="button" className="btn btn"><span >Investigation Approvals</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-lab"><button type="button" className="btn btn"><span >Lab Collection Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-inv"><button type="button" className="btn btn"><span >Investigation Collection</span></button></a></div>


                    </div>
                    </div>


                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >OP Details</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/pat-bill-search"><button type="button" className="btn btn"><span >Patient Billing Details</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-patient"><button type="button" className="btn btn"><span >New Patient- registration</span></button></a></div>
                    <div className="btn-group">
                    <a href="/pat-search"><button type="button" className="btn btn"><span >Patient ID Print</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >OP Billing Masters</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-subcat"><button type="button" className="btn btn"><span >Add Lab Master</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-radio"><button type="button" className="btn btn"><span >Add Radiology Master</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-template"><button type="button" className="btn btn"><span >Add Template Master</span></button></a></div>

                    </div>
                    </div>

               </div>
            </div>
        </section>
    )
}

export default FrontMenu;